const OPTIMIZELY_DISABLED_FEATURES_OVERRIDE_KEY = 'OPTIMIZELY_DISABLED_FEATURES'
const OPTIMIZELY_ENABLED_FEATURES_OVERRIDE_KEY = 'OPTIMIZELY_ENABLED_FEATURES'

const OPTIMIZELY_DISABLED_FEATURES_KEYS = {
  storageKey: OPTIMIZELY_DISABLED_FEATURES_OVERRIDE_KEY,
  envKey: `REACT_APP_${OPTIMIZELY_DISABLED_FEATURES_OVERRIDE_KEY}`,
} as const

const OPTIMIZELY_ENABLED_FEATURES_KEYS = {
  storageKey: OPTIMIZELY_ENABLED_FEATURES_OVERRIDE_KEY,
  envKey: `REACT_APP_${OPTIMIZELY_ENABLED_FEATURES_OVERRIDE_KEY}`,
} as const

const loadDataFromStorage = (storageKey: string): string | null =>
  window.localStorage.getItem(storageKey)

const getFeatures = (
  featuresKeys:
    | typeof OPTIMIZELY_ENABLED_FEATURES_KEYS
    | typeof OPTIMIZELY_DISABLED_FEATURES_KEYS,
) =>
  (
    loadDataFromStorage(featuresKeys.storageKey) ??
    process.env[featuresKeys.envKey]
  )
    ?.trim()
    .split(',') ?? []

/**
 *
 * This is helper for local development and testing which allow users to override Optimizely config.
 *
 * If you want to overwrite optimizely FF for local development, go inside .env file and
 * set following variables:
 * eg.
 * REACT_APP_OPTIMIZELY_ENABLED_FEATURES=access_management,billing
 * REACT_APP_OPTIMIZELY_DISABLED_FEATURES=some_other_feature
 *
 * If you want to overwrite optimizely FF while using deployed app e.g. review app or develop version, go to local storage
 * and set following variables:
 * eg.
 * OPTIMIZELY_ENABLED_FEATURES=access_management,billing
 * OPTIMIZELY_DISABLED_FEATURES=some_other_feature
 *
 * The example above will set access_management and billing features to true, and some_other_feature to false
 */
export const getOptimizelyOverrides = () => {
  const onFeatures = getFeatures(OPTIMIZELY_ENABLED_FEATURES_KEYS)

  const offFeatures = getFeatures(OPTIMIZELY_DISABLED_FEATURES_KEYS)

  const reducer =
    (value: boolean) => (obj: Record<string, boolean>, feature: string) => ({
      ...obj,
      [feature]: value,
    })

  return {
    ...onFeatures.filter(Boolean).reduce(reducer(true), {}),
    ...offFeatures.filter(Boolean).reduce(reducer(false), {}),
  }
}
